// Active theme's palette. The real values live in src/themes/<active>/palette.js;
// switch the whole app by changing ACTIVE_THEME in src/themes/index.js.
// Components keep importing { NAVY, GOLD, WHITE, DANGER } from here exactly as before.
import { theme } from "../themes";

const p = theme.palette;
export const NAVY   = p.NAVY;
export const GOLD   = p.GOLD;
export const WHITE  = p.WHITE;
export const DANGER = p.DANGER;
